import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useSyncAppleDeveloperAgreementsForAllBrandsMutation$data,
  useSyncAppleDeveloperAgreementsForAllBrandsMutation as useSyncAppleDeveloperAgreementsForAllBrandsMutationType,
} from "./__generated__/useSyncAppleDeveloperAgreementsForAllBrandsMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useSyncAppleDeveloperAgreementsForAllBrandsMutation {
    syncAppleDeveloperAgreementsForAllBrands {
      ... on BrandType {
        id
        appleDeveloperAgreementsPendingSince
        showIosTosAlert
      }
    }
  }
`;

const useSyncAppleDeveloperAgreementsForAllBrandsMutation = (): [
  (
    onCompleted?: (
      data: useSyncAppleDeveloperAgreementsForAllBrandsMutation$data
    ) => void
  ) => void,
  boolean
] => {
  const [syncMutation, isMutationInFlight] =
    useMutation<useSyncAppleDeveloperAgreementsForAllBrandsMutationType>(
      mutation
    );
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      onCompleted?: (
        data: useSyncAppleDeveloperAgreementsForAllBrandsMutation$data
      ) => void
    ) => {
      syncMutation({
        variables: {},
        onCompleted: (data, errors) => {
          if (errors) {
            snackbarContext?.openSnackbar("Sync failed", "error");
          } else {
            onCompleted && onCompleted(data);
            snackbarContext?.openSnackbar(
              "Apple developer agreements synced",
              "success"
            );
          }
        },
        onError: (error: Error) => {
          snackbarContext?.openSnackbar("Sync failed", "error");
        },
      });
    },
    [snackbarContext, syncMutation]
  );

  return [onMutate, isMutationInFlight];
};

export default useSyncAppleDeveloperAgreementsForAllBrandsMutation;
